import React from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import JustLaunched from "../components/JustLaunched";
import Hero from "../sections/Hero";
import Section1 from "../sections/Section1";
import Section2 from "../sections/Section2";
import Section3 from "../sections/Section3";
import Section4 from "../sections/Section4";
import Section5 from "../sections/Section5";
import Section6 from "../sections/Section6";
import FAQ from "./FAQ";

const Landing = () => {
  return (
    <div>
      <JustLaunched />
      <Header />
      <Hero />
      <Section1 />
      <Section2 />
      {/*       <Section3 /> */}
      <Section5 />
      <Section4 />
      <FAQ />
      <Section6 />
      <Footer />
    </div>
  );
};

export default Landing;
